/**
 * Afuna Aromatics — Homepage pathway hero (mobile manual selector only).
 *
 * Progressive enhancement:
 *  - No JS: desktop shows all three panels; mobile stacks all three panels,
 *    so every pathway is reachable.
 *  - With JS: adds .aa-pathway-hero--enhanced, which collapses the mobile
 *    view to one active 4:5 panel plus the three manual controls. Desktop is
 *    unchanged (always three panels).
 *
 * No autoplay, no timers, no swipe requirement, no third-party library.
 * The currently shown image stays visible until the next image has decoded,
 * so a pathway switch never flashes a blank panel. Reduced motion is
 * respected implicitly: the switch is an instant display swap.
 */
(function () {
  var STATES = ['release', 'remember', 'reign'];

  function enhance(root) {
    var controls = root.querySelectorAll('.aa-pathway-hero__control');
    if (!controls.length) return;

    root.classList.add('aa-pathway-hero--enhanced');

    function wrapFor(state) {
      return root.querySelector('.aa-pathway-hero__panel-wrap--' + state);
    }

    function setActive(state) {
      if (STATES.indexOf(state) === -1) return;
      if (root.getAttribute('data-active') === state) return;

      var wrap = wrapFor(state);
      if (!wrap) return;
      var img = wrap.querySelector('img');

      var apply = function () {
        root.setAttribute('data-active', state);
        controls.forEach(function (c) {
          c.setAttribute(
            'aria-pressed',
            c.getAttribute('data-pathway') === state ? 'true' : 'false'
          );
        });
      };

      // Load (if still lazy/deferred) and decode the target image before the
      // swap so the outgoing panel stays on screen until the new one is ready.
      if (img && typeof img.decode === 'function') {
        if (img.loading === 'lazy') img.loading = 'eager';
        img.decode().then(apply).catch(apply);
      } else {
        apply();
      }
    }

    controls.forEach(function (c) {
      c.addEventListener('click', function () {
        setActive(c.getAttribute('data-pathway'));
      });
    });

    // Normalise the starting state without moving focus or scrolling.
    var start = root.getAttribute('data-active');
    if (STATES.indexOf(start) === -1) start = 'release';
    root.setAttribute('data-active', start);
    controls.forEach(function (c) {
      c.setAttribute(
        'aria-pressed',
        c.getAttribute('data-pathway') === start ? 'true' : 'false'
      );
    });
  }

  document.querySelectorAll('.aa-pathway-hero').forEach(enhance);

  /**
   * Consolidated refinement 2026-08-29 / WP F.1 — homepage founder media.
   * The founder portrait renders through the theme's generic image block,
   * whose srcset tops out at width=3840. The current founder file
   * (Renee_Blue_dress_long.png) is ~3461px wide, so the 3840w srcset entry
   * IS the multi-megabyte original, and the block's sizes="...100vw" hint
   * let the browser select it — a very large fetch for a portrait that
   * actually renders at ~640px, seen by founder review as an intermittent
   * blank framed image on slower / mobile loads.
   *
   * This corrects ONLY the loading reference for that one homepage image:
   * it rebuilds srcset from the SAME asset's Shopify CDN renditions capped
   * at a sensible width, and sets a matching `sizes`, so the browser stops
   * fetching the full-size original. No asset, product media record, image
   * block, section, or template is changed; the image stays lazy (below the
   * fold) and its square-corner + 1px editorial border are untouched.
   */
  (function fixFounderMediaLoading() {
    var section = document.querySelector('[id$="__section_founderHome"]');
    if (!section) return;
    var img = section.querySelector('img.image-block__image') || section.querySelector('img');
    if (!img) return;
    var raw = img.currentSrc || img.getAttribute('src') || '';
    var base = raw.split('?')[0];
    if (!base || base.indexOf('/cdn/') === -1) return; // only touch a Shopify CDN image
    if (img.getAttribute('data-aa-founder-loading-fixed') === '1') return;
    img.setAttribute('data-aa-founder-loading-fixed', '1');
    img.setAttribute(
      'srcset',
      base + '?width=480 480w, ' + base + '?width=768 768w, ' + base + '?width=1024 1024w, ' + base + '?width=1280 1280w'
    );
    img.setAttribute('sizes', '(min-width: 750px) 640px, calc(100vw - 32px)');
    if (raw.indexOf('width=') === -1 || parseInt((raw.match(/width=(\d+)/) || [])[1] || '0', 10) > 1280) {
      img.setAttribute('src', base + '?width=1280');
    }
  })();
})();
